import { React } from 'react'
import Hero from './components/Hero'
import './styles/phantom.scss'
import PhantomMain from './components/hero-items/PhantomMain'
import Character from './components/Character'
import './data/PhantomData'
import PhantomData from './data/PhantomData'
import Pengu from './components/Pengu'
import './styles/components/hero-items/game-main.scss'
import './styles/components/hero.scss'

const Phantom = () => {
    const data = [
        {
            className: 'home',
            first: '',
            second: '/img/keyart/banner-first.jpg',
            gradOne: '.25turn, rgba(3,53,116, 1) 70%, rgba(3,53,116, 1) )',
            gradTwo: '.75turn, rgba(0,0,0,0) 75%, rgba(3,53,116, 1))',
            logo: './img/logos/PB_logo_Remastered_small.png',
            hide: 'true',
            color: 'rgba(3,53,116, 1)',
        },
    ]
    return (
        <>
            <div className='phantom-container'>
                <Hero
                    className='home'
                    first=''
                    second='/img/keyart/banner-first.jpg'
                    gradOne='.25turn, rgba(3,53,116, 1) 70%, rgba(3,53,116, 1) )'
                    gradTwo='.75turn, rgba(0,0,0,0) 75%, rgba(3,53,116, 1))'
                    logo='./img/logos/PB_logo_Remastered_small.png'
                    hide='true'
                    color='rgba(3,53,116, 1)'
                    contents={<PhantomMain />}
                />
                <section className=''>
                    {/* <div style={{ padding: '10px' }} className='pb2link'>
                        <a target='_blank' rel='noreferrer' href='https://nisamerica.com/phantombrave-the-lost-hero/'>
                            <img className='pb2-button' src='./img/logos/button.jpg' alt='Phantom Brave 2 link' />{' '}
                        </a>{' '}
                    </div> */}
                    <div className='story-container'>
                        <div className='story-wrapper'>
                            <div className='story-info'>
                                <div className='image-wrapper'>
                                    <img src='./img/logos/phantom-story.png' alt='STORY' className='story-title' />
                                </div>
                                <p className='story-body'>
                                    In the year of 913, in a world called Ivoire, lives Marona, a 13 year old orphaned
                                    girl with a special ability to communicate with phantoms. Her ability brings
                                    resentment from others, but cheerful and optimistic Marona is not bothered. Marona
                                    believes in her parents' teachings that people will one day come to like her as long
                                    as she stays compassionate and kind. Now Marona travels throughout Ivoire with her
                                    guardian, "Ash the Phantom," to resolve disputes around the world.
                                </p>
                            </div>
                            <div className='story-art'>
                                <img src='./img/keyart/phantom-keyart1.jpg' alt='phantom-keyart' />
                            </div>
                        </div>
                    </div>{' '}
                </section>
                <Character charList={PhantomData} showStats={true} game='phantom' />
                <Pengu link='./products' />
            </div>
        </>
    )
}

export default Phantom
